// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__2KLpo","headerIcon":"header_headerIcon__2r4gs","headerText":"header_headerText__1AU4-"};